import {
  SpecialsGrid as MenuSpecialsGrid,
  SPECIALS_GRID_LIMIT,
  SpecialCard,
  getSpecialSlug,
} from '@iheartjane/menu';
import { Button, Flex } from '@iheartjane/reefer';
import type { Nullable, ReservationModeLabels } from '@iheartjane/types';
import { useState } from 'react';

import { useFullDestination } from '@jane/bloom/hooks/navigation/useFullDestination';
import { trackStoreSpecialTap } from '@jane/bloom/services/tracking/track';
import type { StoreSpecial } from '@jane/bloom/types/schemas/marketplace/storeSpecials';
import type { ComplianceLanguage } from '@jane/bloom/types/schemas/roots/complianceLanguage';

import { SpecialCard as OldSpecialCard } from './specialCard';

type SpecialsGridProps = {
  className?: string;
  complianceLanguage?: Nullable<ComplianceLanguage>;
  reservationModeLabels?: ReservationModeLabels;
  specialsRedesignMenu?: boolean;
  storeSpecials: StoreSpecial[];
};

export function SpecialsGrid({
  className,
  complianceLanguage,
  reservationModeLabels,
  specialsRedesignMenu,
  storeSpecials,
}: SpecialsGridProps) {
  const [showAll, setShowAll] = useState(false);
  const generatePath = useFullDestination();
  const visibleSpecials = storeSpecials.slice(
    0,
    !showAll ? SPECIALS_GRID_LIMIT : undefined
  );
  const hasMore = !showAll && storeSpecials.length > SPECIALS_GRID_LIMIT;

  if (storeSpecials.length === 0) return null;

  return (
    <div className={className}>
      <MenuSpecialsGrid>
        {visibleSpecials.map((special, index) =>
          specialsRedesignMenu ? (
            <SpecialCard
              key={special.id}
              customSpecialBadge={special?.custom_badge}
              discountAmount={special?.discount_amount}
              discountType={special?.discount_type}
              imageSrc={special?.photo?.urls?.original}
              isPremium
              reservationModeLabels={reservationModeLabels}
              reservationModes={special?.reservation_modes}
              specialType={special?.special_type}
              storeComplianceLanguageSettings={complianceLanguage}
              title={special.title}
              to={generatePath(
                `/deals/${special.id}/${getSpecialSlug(special.title)}`
              )}
              onClick={() =>
                trackStoreSpecialTap({
                  source: 'specials row',
                  specialId: special.id,
                  specialRankOnList: index + 1,
                  specialType: special.special_type,
                })
              }
            />
          ) : (
            <OldSpecialCard
              key={special.id}
              special={special}
              complianceLanguage={complianceLanguage}
            />
          )
        )}
      </MenuSpecialsGrid>
      {hasMore && (
        <Flex justifyContent="center" mt={24}>
          <Button
            label="Load more"
            variant="tertiary"
            onClick={() => setShowAll(true)}
          />
        </Flex>
      )}
    </div>
  );
}
